/* FRAMESI · fx-ola-cabecera.js
   Ola «Antes del Buen Fin» (1-nov-2026), grupo T3. Lo carga sections/header.liquid (una sola vez).

   1 · Fase de la promoción por fecha de México (renglón 31). El Liquid pinta las tres fases y deja
       `hidden` en las que no tocan según la hora de la tienda; aquí se recalcula en el navegador con la
       hora de la Ciudad de México porque la página puede venir de caché. Usa siempre `new Date()` (nunca
       Intl.DateTimeFormat().format() sin argumento) para que se pueda probar sobrescribiendo Date.
       Prueba: fxOlaCabecera.aplicarFase() vuelve a calcular con el Date que haya en ese momento.
   2 · Cinta de /discount/CODIGO (renglón 31): lee la cookie `discount_code` y /cart.js.
   3 · Encabezado que se esconde al bajar y regresa al subir; en celular, compacto a 56 px (renglón 37).
   4 · Columnas del pie en acordeón en celular (renglón 53, parte del pie).
   5 · Botón «Copiar código» de /pages/promociones. */
(function () {
  'use strict';
  if (window.__fxOlaCabecera) return;
  window.__fxOlaCabecera = true;

  var TZ = 'America/Mexico_City';
  var mqCel = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

  /* ---------- datos (los escribe snippets/fx-ola-promos.liquid) ---------- */
  var datos = (function () {
    var def = { codigo: 'FRAMESI20', pct: 20, min: 79900, hasta: 20261112, bf_desde: 20261113, bf_hasta: 20261117, v3: false };
    var el = document.getElementById('fx-ola-datos');
    if (!el) return def;
    try {
      var d = JSON.parse(el.textContent);
      for (var k in def) { if (!(k in d)) d[k] = def[k]; }
      return d;
    } catch (e) { return def; }
  })();

  /* ---------- fecha de México ---------- */
  function ymdMx(d) {
    try {
      var s = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
      var n = parseInt(s.replace(/-/g, ''), 10);
      if (n > 20000101) return n;
    } catch (e) { /* sin Intl: cae al respaldo */ }
    /* México no tiene horario de verano desde 2022: la hora del centro es UTC-6 todo el año. */
    var u = new Date(d.getTime() - 6 * 3600 * 1000);
    return u.getUTCFullYear() * 10000 + (u.getUTCMonth() + 1) * 100 + u.getUTCDate();
  }
  function fase() {
    var y = ymdMx(new Date());
    return y <= datos.hasta ? 1 : (y <= datos.bf_hasta ? 2 : 3);
  }

  /* ---------- encabezado: medida, escondido y compacto ---------- */
  var cab = null;
  var cabAlto = 0;
  var estado = { oculta: false, compacta: false };
  var lastY = 0;
  var acum = 0;
  var DESDE = 80;   /* por encima de esto el encabezado se ve completo */
  var BAJA = 6;     /* px bajando para esconderlo */
  var SUBE = 10;    /* px subiendo para regresarlo: «en cuanto la persona sube un poco» */

  function medirCabecera() {
    if (!cab || estado.compacta) return;   /* el alto que se reserva es el completo, nunca el compacto */
    var h = Math.round(cab.getBoundingClientRect().height);
    if (h > 0 && h !== cabAlto) {
      cabAlto = h;
      document.documentElement.style.setProperty('--fx-cab-alto', h + 'px');
    }
  }

  function aplicarEstado(oculta, compacta) {
    if (!cab) return;
    var comp = !!compacta && mqCel.matches;
    if (oculta !== estado.oculta) {
      estado.oculta = oculta;
      cab.classList.toggle('fx-cab--oculta', oculta);
    }
    if (comp !== estado.compacta) {
      estado.compacta = comp;
      cab.classList.toggle('fx-cab--compacta', comp);
      if (!comp) medirCabecera();
    }
  }

  function hayPanelAbierto() {
    var b = document.body;
    if (!b) return false;
    var c = b.classList;
    if (c.contains('overflow-hidden') || c.contains('overflow-hidden-mobile') || c.contains('overflow-hidden-tablet')) return true;
    if (document.querySelector('.menu-drawer.show, .search-sheet.show, cart-drawer.active')) return true;
    if (cab && cab.querySelector('[aria-expanded="true"]')) return true;
    /* Foco de teclado dentro del encabezado: se queda visible. Un botón que se tocó con el dedo o el
       ratón conserva el foco pero no es :focus-visible, y ese no debe impedir que se esconda. */
    var a = document.activeElement;
    if (cab && a && cab.contains(a)) {
      try { if (a.matches(':focus-visible')) return true; } catch (e) { /* navegador viejo */ }
    }
    return false;
  }

  function alScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    y = Math.min(Math.max(0, y), max);   /* el rebote de iOS pasa por valores fuera de rango */
    var d = y - lastY;
    lastY = y;
    if (hayPanelAbierto()) { acum = 0; return; }
    if (y <= DESDE) { acum = 0; aplicarEstado(false, false); return; }
    if (d === 0) return;
    if ((d > 0) !== (acum > 0)) acum = 0;
    acum += d;
    if (acum > BAJA) { aplicarEstado(true, true); }
    else if (acum < -SUBE) { aplicarEstado(false, true); }
  }

  function iniciarCabecera() {
    cab = document.getElementById('framesi-fixed-header');
    if (!cab) return;
    medirCabecera();
    document.documentElement.classList.add('fx-cab-activo');
    lastY = window.pageYOffset || 0;
    if (lastY > DESDE) aplicarEstado(false, true);   /* se recargó con la página ya bajada */
    window.addEventListener('scroll', alScroll, { passive: true });
    /* con teclado, Tab entra al encabezado aunque esté escondido: se muestra */
    cab.addEventListener('focusin', function () { aplicarEstado(false, estado.compacta); });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { medirCabecera(); }).observe(cab);
    }
    var cambio = function () {
      if (!mqCel.matches && estado.compacta) aplicarEstado(estado.oculta, false);
      medirCabecera();
    };
    if (mqCel.addEventListener) mqCel.addEventListener('change', cambio);
    else if (mqCel.addListener) mqCel.addListener(cambio);
    window.addEventListener('orientationchange', function () { setTimeout(medirCabecera, 250); });
  }

  /* ---------- cinta de /discount/CODIGO ---------- */
  function leerCookie(nombre) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + nombre + '=([^;]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function dinero(centavos) {
    var v = centavos / 100;
    var entero = Math.abs(v - Math.round(v)) < 0.005;
    return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: entero ? 0 : 2, maximumFractionDigits: 2 });
  }
  var NBSP = ' ';
  var cintaSolicitud = 0;

  function ponerCinta(cinta, partes) {
    var tx = cinta.querySelector('[data-fx-cinta-tx]');
    if (!tx) return;
    tx.textContent = '';
    for (var i = 0; i < partes.length; i++) {
      if (partes[i].b) { var b = document.createElement('b'); b.textContent = partes[i].t; tx.appendChild(b); }
      else tx.appendChild(document.createTextNode(partes[i].t));
    }
    cinta.hidden = false;
    medirCabecera();
  }

  function actualizarCinta() {
    var cinta = document.querySelector('[data-fx-cinta]');
    if (!cinta) return;
    var codigo = leerCookie('discount_code').toUpperCase();
    /* Solo un código conocido pinta algo: uno desconocido puede ser de salón. */
    if (!codigo || codigo !== String(datos.codigo).toUpperCase()) { cinta.hidden = true; medirCabecera(); return; }
    try { if (window.sessionStorage.getItem('fx-cinta-x-' + codigo)) { cinta.hidden = true; medirCabecera(); return; } } catch (e) { /* sin sessionStorage */ }
    if (ymdMx(new Date()) > datos.hasta) {
      ponerCinta(cinta, [{ t: 'El código ' }, { t: codigo, b: true }, { t: ' terminó el 12 de noviembre.' }]);
      return;
    }
    var mi = ++cintaSolicitud;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mi !== cintaSolicitud) return;
        var falta = datos.min - (cart.items_subtotal_price || 0);
        var base = [{ t: codigo + ' aplicado', b: true }, { t: ': ' + datos.pct + NBSP + '% desde ' + dinero(datos.min) }];
        if (falta > 0) base.push({ t: ', te faltan ' + dinero(falta) + '.' });
        else base.push({ t: '. Tu carrito ya llega al mínimo.' });
        ponerCinta(cinta, base);
      })
      .catch(function () {
        if (mi !== cintaSolicitud) return;
        ponerCinta(cinta, [{ t: codigo + ' aplicado', b: true }, { t: ': ' + datos.pct + NBSP + '% desde ' + dinero(datos.min) + '.' }]);
      });
  }

  function vigilarCarrito() {
    var pendiente = null;
    var refrescar = function () { clearTimeout(pendiente); pendiente = setTimeout(actualizarCinta, 400); };
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && window.MutationObserver) {
      new MutationObserver(refrescar).observe(burbuja, { childList: true, subtree: true, characterData: true, attributes: true });
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refrescar);
      }
    } catch (e) { /* el tema no trae pubsub */ }
  }

  /* ---------- barra: si la versión larga no cabe, se usa la corta ---------- */
  function ajustarBarra() {
    var a = document.querySelector('a.fx-ba');
    if (!a) return;
    a.classList.remove('fx-ba--corta');
    var f = a.querySelector('.fx-ba__fase:not([hidden])');
    var l = f ? f.querySelector('.fx-ba__l') : null;
    if (l && window.getComputedStyle(l).display !== 'none' && f.scrollWidth > f.clientWidth + 1) {
      a.classList.add('fx-ba--corta');
    }
  }

  /* ---------- fase: mostrar solo lo que toca ---------- */
  function aplicarFase() {
    var f = fase();
    var nodos = document.querySelectorAll('[data-fx-fase]');
    for (var i = 0; i < nodos.length; i++) {
      nodos[i].hidden = nodos[i].getAttribute('data-fx-fase') !== String(f);
    }
    var msg = document.querySelector('[data-fx-ola-barra]');
    if (msg) {
      msg.hidden = !msg.querySelector('.fx-ba__fase:not([hidden])');
      var ann = msg.closest ? msg.closest('.announce') : null;
      if (ann) ann.hidden = !ann.querySelector('.announce__message:not([hidden])');
    }
    document.documentElement.setAttribute('data-fx-fase-actual', String(f));
    ajustarBarra();
    medirCabecera();
    actualizarCinta();
    return f;
  }

  /* ---------- pie: columnas en acordeón en celular ---------- */
  function iniciarPie() {
    var cols = document.querySelectorAll('details.fx-pie-col');
    if (!cols.length) return;
    function ajustar() {
      var cel = mqCel.matches;
      for (var i = 0; i < cols.length; i++) {
        cols[i].open = !cel;   /* celular: plegadas al cargar; escritorio: siempre abiertas */
        var s = cols[i].querySelector('summary');
        if (s) { if (cel) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1'); }
      }
    }
    ajustar();
    if (mqCel.addEventListener) mqCel.addEventListener('change', ajustar);
    else if (mqCel.addListener) mqCel.addListener(ajustar);
    document.addEventListener('click', function (e) {
      var s = e.target.closest ? e.target.closest('details.fx-pie-col > summary') : null;
      if (s && !mqCel.matches) e.preventDefault();   /* en escritorio las columnas no se pliegan */
    });
  }

  /* ---------- clics: cerrar la cinta y copiar el código ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-fx-cinta-x], [data-fx-copiar]') : null;
    if (!t) return;
    if (t.hasAttribute('data-fx-cinta-x')) {
      var cinta = t.closest('[data-fx-cinta]');
      if (cinta) {
        cinta.hidden = true;
        try { window.sessionStorage.setItem('fx-cinta-x-' + String(datos.codigo).toUpperCase(), '1'); } catch (er) { /* sin sessionStorage */ }
        medirCabecera();
      }
      return;
    }
    var codigo = t.getAttribute('data-fx-copiar');
    var original = t.getAttribute('data-fx-copiar-txt') || t.textContent;
    t.setAttribute('data-fx-copiar-txt', original);
    var listo = function () {
      t.textContent = 'Código copiado';
      setTimeout(function () { t.textContent = original; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(listo, function () { t.textContent = 'Escríbelo al pagar: ' + codigo; });
    } else {
      var ta = document.createElement('textarea');
      ta.value = codigo; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); listo(); } catch (er) { t.textContent = 'Escríbelo al pagar: ' + codigo; }
      document.body.removeChild(ta);
    }
  });

  /* ---------- arranque ---------- */
  aplicarFase();
  iniciarCabecera();
  vigilarCarrito();
  iniciarPie();
  setInterval(aplicarFase, 60000);   /* cambia de fase a medianoche aunque la pestaña siga abierta */
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') aplicarFase(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) aplicarFase(); });
  var rz = null;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { ajustarBarra(); medirCabecera(); }, 150); });

  window.fxOlaCabecera = { aplicarFase: aplicarFase, fase: fase, ymdMx: ymdMx, actualizarCinta: actualizarCinta };
})();
